import { getAutomationById } from '../automation';
import { Evaluator } from '@/types/evaluator';
import { Timestamp } from 'firebase/firestore';
import { toast } from 'react-hot-toast';

// Helper function to format timestamps
function formatTimestamp(timestamp: Timestamp | null): string | null {
  if (!timestamp || !timestamp.toDate) {
    return null;
  }
  return timestamp.toDate().toISOString();
}

// Main notification function
export async function notifyEvaluatorNominated(evaluator: Evaluator): Promise<void> {
  try {
    const automation = await getAutomationById('evaluator-nominated');
    if (!automation?.url) {
      console.warn('Evaluator nomination service not available - skipping notification');
      return;
    }

    const payload = {
      id: evaluator.id,
      userId: evaluator.userId,
      firstName: evaluator.firstName,
      lastName: evaluator.lastName,
      email: evaluator.email,
      originalEmail: evaluator.originalEmail,
      uniqueCode: evaluator.uniqueCode,
      contextualized: evaluator.contextualized,
      evaluationCompleted: evaluator.evaluationCompleted,
      emailVerified: evaluator.emailVerified,
      lastReminderSentAt: formatTimestamp(evaluator.lastReminderSentAt),
      createdAt: formatTimestamp(evaluator.createdAt),
      updatedAt: formatTimestamp(evaluator.updatedAt),
      action: 'evaluator_nominated'
    };

    const response = await fetch(automation.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {      
      console.warn('Failed to send evaluator nomination notification');
      return;
    }
  } catch (error) {
    // Log error but don't throw - notification failure shouldn't block the main flow
    console.warn('Error sending evaluator nomination notification:', error);
  }
}